import { CONST } from "../../CONST";

const WHITE_IMG_DEPTH = 16;
const DARK_IMG_DEPTH = 15;

//animation
const MOUSE_OVER_SIZE = 1.2;
const ANIM_DURATION = 100;
const EASING = "Quad.easeOut";

export const SIM_CLICK_PRE_ANIM_DURATION = 250;
const SIM_CLICK_AFTER_ANIM_DURATION = 200;

interface KeyConfig {
    key: number;
    x: number;
    y: number;
    darkImage: string;
    whiteImage: string;
    audio: string,
}

export enum KeyState{
    Playing = 1,
    Listening,
    Transitioning
}

export class Key {
    key: number;
    darkImage: Phaser.GameObjects.Image;
    whiteImage: Phaser.GameObjects.Image;
    errorImage: Phaser.GameObjects.Image;
    audio: string;
    
    darkTween !: Phaser.Tweens.Tween;
    whiteTween !: Phaser.Tweens.Tween;
    scene: Phaser.Scene;

    mouseOver: boolean = false;
    state: KeyState;
    clickCallback !: () => void;

  constructor(scene : Phaser.Scene, keyConfig : KeyConfig, keyState : KeyState) {
    this.key = keyConfig.key;
    this.audio = keyConfig.audio;

    const xPos = keyConfig.x;
    const yPos = keyConfig.y;
    this.darkImage = scene.add.image(xPos, yPos, keyConfig.darkImage)
        .setDepth(DARK_IMG_DEPTH)
        .setInteractive({
            useHandCursor: true,
            pixelPerfect: true,
            alphaTolerance: 1
        });
    
    this.darkImage.on("pointerover", () => {
                        this.mouseOver = true;
                        if (this.state == KeyState.Playing){
                            this.setHighlight(true);
                        }
                    })
                    .on("pointerout", () => {
                        this.mouseOver = false;
                        if (this.state == KeyState.Playing){
                            this.setHighlight(false);
                        }
                    })
                    .on("pointerdown", () => {
                        if (this.state != KeyState.Playing) return;
                        this.click();
                    });

    this.whiteImage = scene.add.image(xPos, yPos, keyConfig.whiteImage)
        .setDepth(WHITE_IMG_DEPTH)
        .setAlpha(0);

    this.errorImage = scene.add.image(xPos, yPos, keyConfig.whiteImage)
        .setDepth(WHITE_IMG_DEPTH+0.1)
        .setScale(MOUSE_OVER_SIZE)
        .setAlpha(0)
        .setTint(0xff0000);



    this.scene = scene;

    this.state = keyState;
  }

  bounce(){
    this.whiteImage.setScale(1, 1);
    this.darkImage.setScale(1, 1);
    this.setHighlight(true);
  }

  setHighlight(highlighted : boolean, duration : number = ANIM_DURATION){
    //if (highlighted && this.state != KeyState.Playing) return;
    if (this.darkTween) this.darkTween.stop();
    if (this.whiteTween) this.whiteTween.stop();
    if (highlighted){
        this.whiteTween = this.scene.tweens.add({
            targets: this.whiteImage,
            alpha: 1,
            scaleX: MOUSE_OVER_SIZE,
            scaleY: MOUSE_OVER_SIZE,
            ease: EASING,
            duration: duration,
        });
    
        this.darkTween = this.scene.tweens.add({
            targets: this.darkImage,
            scaleX: MOUSE_OVER_SIZE,
            scaleY: MOUSE_OVER_SIZE,
            ease: EASING,
            duration: duration,
        });
    } else {
        this.whiteTween = this.scene.tweens.add({
            targets: this.whiteImage,
            alpha: 0,
            scaleX: 1,
            scaleY: 1,
            ease: EASING,
            duration: duration,
        });
    
        this.darkTween = this.scene.tweens.add({
            targets: this.darkImage,
            scaleX: 1,
            scaleY: 1,
            ease: EASING,
            duration: duration,
        });
    }
  }

  click(){
      this.bounce();
      
      setTimeout( () => {
        this.scene.sound.play(this.audio);
      }, SIM_CLICK_PRE_ANIM_DURATION);

      if (this.state == KeyState.Playing){
        this.clickCallback();
      }
  }

  simulateClick(){
      //stage 1: animate highlight
      this.setHighlight(true, SIM_CLICK_PRE_ANIM_DURATION);

      //stage 2: click + bounce
      setTimeout(() => {
        this.bounce();
        this.scene.sound.play(this.audio);
        }, SIM_CLICK_PRE_ANIM_DURATION);

        //stage 3: highlight out
        setTimeout( () => {
            this.setHighlight(false, SIM_CLICK_AFTER_ANIM_DURATION);
        }, SIM_CLICK_PRE_ANIM_DURATION + SIM_CLICK_AFTER_ANIM_DURATION);
     
  }

  displayMistake(){
    setTimeout(() => {
        this.scene.sound.play(CONST.AUDIO.INSTRUMENT_FAIL);
    }, SIM_CLICK_PRE_ANIM_DURATION);

      this.scene.tweens.add({
        targets: this.errorImage,
        alpha: 1,
        ease: EASING,
        duration: SIM_CLICK_PRE_ANIM_DURATION,
        hold: 500,
        yoyo: true
    });
  }


  updateState(newState: number) {
    this.state = newState;
    this.setHighlight(this.mouseOver && this.state == KeyState.Playing);
  }
}